import { jsxs as b, jsx as c } from "react/jsx-runtime";
import { clsx as y } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useId as l } from "react";
import { RocheUIIcon as m } from "../../icon/roche-icon.js";
import e from "./roche-search-input.module.scss.js";
import { RocheUISearchInputSize as n } from "./roche-search-input.types.js";
const C = ({
  className: u,
  placeholder: d,
  size: o = n.NORMAL,
  autoWidth: I = !1,
  value: s,
  onChange: f,
  onClear: a,
  ariaLabels: r
}) => {
  const i = l(), h = l(), _ = y(
    e["search-input"],
    u,
    o === n.SMALL && e["search-input--small"],
    I && e["search-input--auto-width"]
  ), N = s && s.length > 0 && a, p = o === n.SMALL ? "1rem" : "1.5rem", S = (t) => {
    t.key === "Escape" && t.preventDefault();
  };
  return /* @__PURE__ */ b("form", { className: _, onSubmit: (t) => t.preventDefault(), role: "search", "aria-label": r.siteSearch, children: [
    /* @__PURE__ */ c("label", { htmlFor: i, className: e["search-input__label"], children: r.searchInputLabel }),
    /* @__PURE__ */ c("span", { id: h, className: e["search-input__description"], children: r.searchInputDescription }),
    /* @__PURE__ */ c("span", { className: e["search-input__search-icon"], "aria-hidden": "true", children: /* @__PURE__ */ c(m, { height: p, icon: "search" }) }),
    /* @__PURE__ */ c(
      "input",
      {
        className: e["search-input__input"],
        id: i,
        type: "search",
        autoComplete: "off",
        value: s,
        onChange: f,
        placeholder: d,
        onKeyDown: S,
        "aria-describedby": h
      }
    ),
    N && /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        onClick: a,
        className: e["search-input__clear-icon"],
        "aria-label": r.clearSearchTerm,
        children: /* @__PURE__ */ c(m, { height: p, icon: "remove" })
      }
    )
  ] });
};
export {
  C as RocheUISearchInput
};
